<AiconeLogo />

<nav
  :class="[
    'navbar navbar-expand-lg bg-white border-bottom border-purple border-opacity-50 px-3 px-lg-4 py-3 sticky-top z-3 config-top-navbar',
    is_full_width ? 'config-top-navbar-overlap' : ''
  ]"
>
  <div class="container-fluid px-0 d-flex align-items-center gap-3">
    <button
      v-if="!hide_hamburger"
      class="btn d-flex d-lg-none align-items-center justify-content-center p-0 border-0 bg-transparent"
      @click="$emit('toggle-sidebar')"
      aria-label="Open menu"
    >
      <i class="bi bi-list fs-3 text-dark"></i>
    </button>

    <div class="config-navbar-brand d-inline-flex align-items-center flex-shrink-0" aria-label="Workspace brand">
      <img :src="$clientLogo" alt="Logo" class="config-navbar-logo">
    </div>

    <div class="flex-grow-1"></div>

    <div class="ms-auto d-flex align-items-center gap-2 gap-lg-3">
      <div class="config-navbar-profile d-flex align-items-center">
        <div class="d-none d-md-flex align-items-center">
          <div class="input-group config-search">
            <span class="input-group-text border-0">
              <i class="bi bi-search"></i>
            </span>
            <input
              type="text"
              class="form-control form-control-sm border-0"
              placeholder="Search cases, requesters, panel members..."
            />
          </div>
        </div>

        <span class="config-navbar-divider d-none d-md-inline-flex" aria-hidden="true"></span>

        <button
          v-if="show_system_switch"
          type="button"
          class="config-navbar-icon btn-link text-dark text-decoration-none d-inline-flex align-items-center justify-content-center border-0 bg-transparent"
          :aria-label="system_switch_aria_label"
          :title="system_switch_aria_label"
          @click="go_to_system_switch"
        >
          <i :class="['bi', system_switch_icon, 'fs-5']"></i>
        </button>

        <a
          href="#"
          class="config-navbar-icon btn-link text-dark text-decoration-none d-inline-flex align-items-center justify-content-center"
          aria-label="Notifications"
        >
          <i class="bi bi-bell fs-5"></i>
        </a>

        <span class="config-navbar-divider" aria-hidden="true"></span>

        <PlatformSwitcher current_platform_id="x-verdict" />

        <a
          href="#"
          class="config-navbar-user text-dark text-decoration-none d-inline-flex align-items-center"
          aria-label="User profile"
        >
          <span class="config-navbar-initials rounded-circle d-inline-flex align-items-center justify-content-center fw-bold">
            {{ user_initials }}
          </span>
          <span class="config-navbar-name fw-semibold">{{ user_name }}</span>
        </a>
      </div>
    </div>
  </div>
</nav>
